export default class AppConstants {
  static HUB_USER_MGMT_EMBEDDED_URL = process.env.HUB_USER_EMBEDDED_URL + '/#/user-mgmt'
  static HUB_SETTING_EMBEDDED_URL = process.env.HUB_USER_EMBEDDED_URL + '/#/hub-setting'
  static DEVICE_REGISTRATION_MGMT_EMBEDDED_URL = process.env.HUB_USER_EMBEDDED_URL + '/#/device-registration-mgmt?embedMode=1'
  static WEB_RCS_EMBEDDED_URL = process.env.WEB_RCS_EMBEDDED_URL + '/'
  static API_URL = process.env.API_URL
  static MOCK_API_URL = '/mock'
  static LOGIN_URL = '/login'
  static HEALTH_CHECK_URL= '/func/health-check'
  static SETTING_WIZARD_URL = '/setting-wizard'
  // ユーザーサイトのURL
  static USER_SITE_URL = process.env.USER_SITE_URL
  // ユーザーサイトのAzureログインパス
  static USER_SITE_AZURE_LOGIN_PATH = 'oidc_login'
  // アカウント管理サービスのベースURL
  static HUB_ACCOUNT_BASE_URL = process.env.HUB_ACCOUNT_BASE_URL
  // アカウント一覧取得
  static HUB_ACCOUNT_LIST_PATH = 'list'
  // 自分のアカウント情報取得
  static HUB_ACCOUNT_PROFILE_PATH = 'me'

  static RESPONSE_200_OK_CODE = 200
  static RESPONSE_401_ERROR_CODE = 401
  static RESPONSE_403_ERROR_CODE = 403
  static RESPONSE_500_ERROR_CODE = 500
  static RESPONSE_502_ERROR_CODE = 502
  static RESPONSE_504_ERROR_CODE = 504
  static RESPONSE_403_ERROR_MSG = 'Forbidden'
  static TOKEN = 'plusa-token'
  static USER_DETAILS = 'plusa-user'

  // ストレージ
  static STORAGE_QUERY_OBJECT = 'query-object'
  static STORAGE_SETTING_WIZARD = 'setting-wizard'
  static STORAGE_DASHBOARD_OBJECT = 'dashboard-data'
  static STORAGE_DASHBOARD_FULLSCREEN_OBJECT = 'dashboard-data-fullscreen'
  static STORAGE_CSV_UPLOAD_TAB_ACTIVE = 'csv-upload-tab-active'
  static STORAGE_MASTER_TABLE_UNLOCK_STATE = 'master-table-unlock-state'
  static STORAGE_WEB_RCS_SETTING = 'web-rcs-setting'
  static STORAGE_LOGIN_MODE = 'login-mode'
  static STORAGE_ACTIVE_ACCOUNT_ENTRA = 'active-account-entra'
  static STORAGE_LOGIN_TIMESTAMP = 'login-timestamp'
  static STOP_INTERVAL_API_FLAG = 'stop-interval-api-flag'

  static BATCH_SELECTED_STORAGE = 'batch-selected'
  static MAIN_CONTENT_ROUTER_NAME = 'Main'
  static TASK_STATEMENT_ROUTER_NAME = 'TaskStatement'
  static CSV_RESULTS_ROUTER_NAME = 'CsvResultsMapping'
  static SETTING_WIZARD_ROUTER_NAME = 'SettingWizard'
  static LOGIN_ROUTER_NAME = 'Login'
  static DASHBOARD_ROUTER_NAME = 'Dashboard'
  static DEV_SETTING_ROUTER_NAME = 'DevSetting'

  static STORAGE_REOPEN_CHUTE_GRID_WINDOW = 'reopenChuteGridWindowFlag'
  static CHUTE_GRID_WINDOW = 'chuteGridWindow'

  static APP_MONTH_DATE_FORMAT = 'MM/DD'
  static APP_MONTH_DATE_TIME_WITHOUT_SECONDS = 'YYYY/MM/DD HH:mm'
  static APP_YEAR_MONTH_DATE_FORMAT = 'YYYY/MM/DD'
  static APP_YEAR_MONTH_DATE_FORMAT_BY_DASH = 'YYYY-MM-DD'

  static DUPLICATE_RECORDS_OPERATION_MODE_REREGISTRATION = 'REREGISTRATION'
  static DUPLICATE_RECORDS_OPERATION_MODE_OVERWRITING = 'OVERWRITING'
  static DUPLICATE_RECORDS_OPERATION_MODE_ERROR = 'ERROR'

  static DUPLICATE_RECORDS_OPERATION_MODE_REREGISTRATION_ST = 'すべて置き換え'
  static DUPLICATE_RECORDS_OPERATION_MODE_OVERWRITING_ST = '差分上書き'
  static DUPLICATE_RECORDS_OPERATION_MODE_ERROR_ST = '重複除外'
  static CSV_UPLOAD = 'CsvUpload'
  static AVATAR_ACCEPT_TYPES = 'image/png, image/bmp, image/gif, image/jpeg'
  static AVATAR_ACCEPT_EXTENTION_TYPES = ['png', 'bmp', 'gif', 'jpg', 'jpeg']
  static MAP_ACCEPT_TYPES = 'image/png, image/jpeg'

  // トピック名
  static TOPIC_DB_CHANGE = '/topic/db-change-notification'
  static TOPIC_SETUP_CHANGE = '/topic/setup-change-notification'

  // work mode
  static WORK_MODE_T_SORT = 1
  static WORK_MODE_RO_BO_HI = 6

  // modal id
  static ID_MODAL_ERROR_MESSAGE_IMPORT = 'id-modal-error-message-import'
  static ID_MODAL_ERROR_MESSAGE_DETAIL = 'id-modal-error-message-detail'
  static ID_MODAL_CONFIRM_DATA_USE = 'modal-confirm-data-use'

  static MST_MENU = {
    BatchControl: true,
    ChuteMapping: true,
    ChuteMaster: true,
    CsvResultsMapping: true,
    CsvUpload: true,
    DetailDeviceMaster: true,
    DeviceMaster: true,
    InductionMaster: true,
    ItemMapping: true,
    ItemMaster: true,
    ShopMapping: true,
    ShopMaster: true,
    SortingMapping: true,
    SortingMaster: true,
    TaskHistory: true,
    TaskMapping: true,
    TaskStatement: true,
    LogInformation: true,
    GeneralSetting: true,
    TsortDashboard: true,
    RoboHiDashboard: true,
    TaskTypeMaster: true,
    TaskTypeSettingMaster: true,
    TaskTypeSetting: true,
    RcsMaster: true,
    DevSetting: true
  }

  // Notify socket message on screens
  static MST_TABLE_MANAGEMENT_PREFIX = 'MstTableManagement_'
  static CHUTE_SOCKET = 'MstChute'
  static BATCH_SOCKET = 'TrBatch'
  static DETAIL_DEVICE_SOCKET = 'MstDetailDevice'
  static DEVICE_SOCKET = 'MstDevice'
  static INDUCTION_SOCKET = 'MstInduction'
  static ITEM_SOCKET = 'MstItem'
  static SHOP_SOCKET = 'MstShop'
  static SORTING_SOCKET = 'MstSorting'
  static RCS_SOCKET = 'MstRcs'
  static TASK_SOCKET = 'TrTask'
  static TASK_TYPE_MST_SOCKET = 'MstTaskType'
  static TASK_TYPE_SETTING_MST_SOCKET = 'MstTaskTypeSetting'
  static TASK_TYPE_SETTING_SOCKET = 'MstTaskType'
  static LOG_SOCKET = 'TrLog'
  static TASK_HISTORY_SOCKET = 'TrTaskHst'
  static SETUP_SOCKET = 'MstSetup'
  static DASHBOARD_SOCKET = ['MstChute', 'TrBatch', 'TrTask', 'MstTaskType']
  static DEV_SETTING_SOCKET = 'MstDevSetting'
  // Entities need to reload page when socket is changed
  static ENTITIES_TO_RELOAD_PAGE = {
    TaskStatement: ['MstTaskType'],
    TaskHistory: ['MstTaskType'],
    SortingMaster: ['MstTaskType'],
    BatchControl: ['MstTaskType']
  }
  // 開発者設定が更新された際にリロードすべき追加上限があるテーブルのリスト
  static ENTITIES_TO_RELOAD_PAGE_WHEN_DEV_SETTING_CHANGED = [
    AppConstants.CHUTE_SOCKET,
    AppConstants.DEVICE_SOCKET,
    AppConstants.DETAIL_DEVICE_SOCKET,
    AppConstants.INDUCTION_SOCKET,
    AppConstants.ITEM_SOCKET,
    AppConstants.RCS_SOCKET,
    AppConstants.SHOP_SOCKET,
    AppConstants.SORTING_SOCKET,
    AppConstants.TASK_SOCKET,
    AppConstants.BATCH_SOCKET
  ]

  // ダッシュボードからリクエスト制限間隔（ミリ秒単位）
  // ソケット通知が多い場合画面更新制限の間隔。
  static DASHBOARD_LAST_SEND_TIME_MILLISECOND = 10000

  // マッピング ルータ リスト
  static MAPPING_ROUTER_LIST = {
    'item': 'ItemMapping',
    'chute': 'ChuteMapping',
    'shop': 'ShopMapping',
    'sorting': 'SortingMapping',
    'task': 'TaskMapping',
    'result': 'CsvResultsMapping'
  }

  // 時間かかるAPIのURLの正規表現
  static MEDIUM_RESPONSE_URL_REGEX = /\/table\/ie\/export\/all\/*|\/func\/batch\/temporary-holding-on|\/func\/batch\/temporary-holding-off|\/func\/batch\/start|\/func\/batch\/cancel|\/func\/batch\/end|\/func\/task\/output-result-file|\/func\/task\/backup-to-taskhst|\/func\/task\/assign|\/func\/task\/dl/
  // 結構時間かかるAPIのURLの正規表現
  static LONG_RESPONSE_URL_REGEX = /\/table\/ie\/import\/*/
  // セットアップ必須なし設定
  static MST_SETTING_NOT_REQUIRED_SETUP = 0
  // ユーザーはメインのセットアップを完了していません
  static MST_SETUP_NOT_FINISHED_SETUP = 0
  // ユーザーがメインのセットアップを完了しました
  static MST_SETUP_FINISHED_SETUP = 1

  // ダッシュボードタスクの進行状況 null
  static DASHBOARD_NO_TASK_PROGRESS_NA = '--'
  static DASHBOARD_ORDER_TASK_PROGRESS_NA = '-- / --'

  // 「NO_TASK_SORT」ユースケースで表示すべきではないマスターパスのリスト。
  static NO_TASK_SORT_HIDDEN_MASTER_PATHS = ['ItemMaster', 'ShopMaster']
  // 「NO_TASK_SORT」の使用例で表示すべきではないマッピングパスのリスト。
  static NO_TASK_SORT_HIDDEN_MAPPING_PATHS = ['ItemMapping', 'ShopMapping', 'TaskMapping']
  // 「NO_TASK_SORT」使用例で表示しないアップロード/エクスポート設定の一覧。
  static NO_TASK_SORT_HIDDEN_LIST = ['item', 'shop', 'task']
  // 「NO_TASK_SORT」ユースケースで表示しない円グラフのステータスタスクのリスト。
  static NO_TASK_SORT_HIDDEN_TASK_PROGRESS_STATUS = ['未割当', '割当済', 'スタンバイ中']

  // キー名
  static WORK_INSTRUCTION_KEY = 'workInstruction'
  static DESCRIPTION_KEY = 'description'
  static DEFAULT_VALUE_KEY = 'defaultValue'

  // 中間システム項目
  static IS_ITEM_FIELD_BATCH_NO = 'batchNo'
  static IS_ITEM_FIELD_TR_TASK = 'trTask'

  // デフォルトのタスクタイプ
  static DEFAULT_ORDER_TASK_SORT = -1
  static DEFAULT_NO_TASK_SORT = -2
  static DEFAULT_TASK_TYPE_LIST = [AppConstants.DEFAULT_ORDER_TASK_SORT, AppConstants.DEFAULT_NO_TASK_SORT]

  // SCSS 変数と値
  static SETTING_WIZARD_MENU_WIDTH = 284
  static DEFAULT_VIEWPORT_WIDTH = 1280
  static MAIN_VIEW_MIN_WIDTH = 900
  // 成功/エラーメッセージのアニメーション時間 (秒)
  static ALERT_MESSAGE_ANIMATION_TIME = '0.3s'
  static DEFAULT_MESSAGE_HEIGHT = 43

  static MAIN_VIEW_WIDTH_VARIABLE_NAME = 'main-view-width'
  static DEFAULT_VIEWPORT_WIDTH_VARIABLE_NAME = 'default-viewport-width'
  static DEFAULT_BROWSER_FONT_SIZE_VARIABLE_NAME = 'default-browser-font-size'
  static ALERT_MESSAGE_ANIMATION_TIME_VARIABLE_NAME = 'alert-message-animation-time'
  static DEFAULT_MESSAGE_HEIGHT_VARIABLE_NAME = 'default-message-height'
  static COMMON_MAPPING_HEAD_HEIGHT_VARIABLE_NAME = 'common-mapping-head-height'
  static SWITCH_BUTTON_WIDTH_VARIABLE_NAME = 'switch-button-width'
  static SWITCH_LABEL_WIDTH_VARIABLE_NAME = 'switch-label-width'

  // 特殊文字の正規表現
  static CSV_PREFIX_PROHIBITED_CHAR_CODES_REGEX = /[-_/＿－‐‑−／\\＼]/g
  static TASK_TYPE_NAME_PROHIBITED_CHAR_CODES_REGEX = /[/／\\＼]/g

  // マッピング WMS 項目の最大レコード数エラー
  static MAPPING_WMS_ITEMS_MAX_RECORD = 500

  // 投稿メッセージタイプの一覧
  static MST_DEVICE_POST_MESSAGE = 'MstDevice'
  static EXPIRED_TOKEN_POST_MESSAGE = 'ExpiredToken'

  // ログインモード
  static ENTRA_LOGIN_MODE = 'entra-oauth'
  static SYSTEM_LOGIN_MODE = 'sys'
}



// WEBPACK FOOTER //
// ./src/constants/app.constants.js